// extracted by mini-css-extract-plugin
export default {"container":"languages_container__9bnWh","selectLabel":"languages_selectLabel__wjKMr","item":"languages_item__VuPWb","selected":"languages_selected__Y9vUP"};